var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSideBySideIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 23,
  viewBox: "0 0 48 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 23,
  rx: 1,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  width: 13,
  height: 23,
  rx: 1,
  fill: "currentColor"
})));
export default SvgSideBySideIcon;